
import { useStoreState } from 'easy-peasy';

export default class Features { 

    constructor() {
        this.settings = useStoreState(state => state.siteSettingsModel);
        //Flinks has been temporarily removed
        //this.linkBankAccountFeatures = ['flinksactive', 'plaidactive'];
        this.linkBankAccountFeatures = ['plaidactive'];
    }

    isAnyFeatureEnabled = (featureNames) => {
        const features = Object.values(this.settings?.websiteSettings || {});
        const normalizedFeatureNames = featureNames.map(featureName => featureName.toLowerCase());

        return features.some(feature =>
            normalizedFeatureNames.includes(feature.Name?.toLowerCase()) &&
            feature.Value?.toLowerCase() === 'true'
        );
    }

    isFeatureEnabled = (feature) => {
        return this.isAnyFeatureEnabled([feature]);
    }

    isLinkBankAccountFeatureEnabled = () => {
        return this.isAnyFeatureEnabled(this.linkBankAccountFeatures);
    }
}